(function ($) {
  let currentPlayer;

  $('[data-toggle="modal"][data-uuid]').on("click", function () {
    const playerUUID = $(this).data("uuid");
    currentPlayer = vidyardEmbed.api.getPlayersByUUID(playerUUID);
    currentPlayer[0].play();
  });

  window.onVidyardAPI = function (vidyardEmbed) {
    vidyardEmbed.api.addReadyListener((_, video) => {
      const videos = vidyardEmbed.players;

      // Pausing all videos when one is played
      video.on("play", function (eventTime) {
        for (let i = 0; i < videos.length; i++) {
          if (videos[i].uuid !== video.uuid) {
            videos[i].pause();
            videos[i].container.parentElement.classList.remove("main");
          }
        }
        video.container.parentElement.classList.add("main");
      });

      // Pausing all videos when modal is closed
      $(".modal.video-gallery-modal").on("hide.bs.modal", function () {
        for (let i = 0; i < videos.length; i++) {
          videos[i].pause();
        }
      });

      video.on("pause", function (eventTime) {
        video.container.parentElement.classList.remove("main");
      });
    });
  };
})(jQuery);
